








































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class CreditCardInfoModal extends Vue {
  @Prop({ default: "icon" }) buttonType?: "icon" | "button";
  @Prop({ default: 0 }) reservationId?: number;

  open = false;

  formValid = false;
  password = "";
  showPassword = false;
  loading = false;

  iframe = false;
  cardToken = "";
  sessionToken = "";
  serviceCodeToken = "";

  submit() {
    this.loading = true;
    Vue.axios
      .post("/channex/ViewCreditCard", {
        password: this.password,
        reservationId: this.reservationId,
      })
      .then((res) => {
        this.cardToken = res.data.cardToken;
        this.sessionToken = res.data.sessionToken;
        this.serviceCodeToken = res.data.serviceCodeToken;
        this.iframe = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  // reset everything when closing the modal
  @Watch("open", { immediate: true })
  openWatch(fresh: boolean, old: boolean) {
    if (old && !fresh) {
      this.formValid = false;
      this.password = "";
      this.showPassword = false;
      this.loading = false;

      this.iframe = false;
      this.cardToken = "";
      this.sessionToken = "";
      this.serviceCodeToken = "";
    }
  }

  required(value: string) {
    return !!value || this.$t("Validation.Required");
  }
}
